<template>
    <div class="p-0">
        <b-button v-b-tooltip.hover title="Editar contenido de la sección" variant="none" class="p-0" @click="$bvToast.show('show-edit-content-title')">
            <i class="fa fa-keyboard-o" :style="{ fontSize: '25px' }"></i>
        </b-button>
        <b-toast id="show-edit-content-title" title="Contenido de la sección" static no-auto-hide
            class="position-absolute p-2 bg-white"
            :style="{ zIndex: 10, boxShadow: '#c4c4c4 0px 0px 18px -3px' }">

            <!-- Titulo -->
            <label for="input-title-field" class="d-flex align-items-center">
                <i class="fa fa-info-circle mr-1 text-primary" aria-hidden="true" v-b-tooltip.hover 
                title="Este campo representa el identificador de la sección actual. No es visible en la impresión."></i>
                <small>Identificador de la sección:</small>
            </label>
            <b-form-input id="input-title-field" size="sm" placeholder="Ingrese el identificador de la sección"
                v-model="activeSection.i"></b-form-input>

            <!-- Ingrese el contenido -->
            <label for="input-text-content"><small>Contenido para la impresión:</small></label>
            <b-form-input id="input-text-content" size="sm" placeholder="Ingrese el contenido para la impresión"
                v-model="activeSection.textContent"></b-form-input>

            <!-- Concatenar texto -->
            <div class="d-flex align-items-center mt-2">
                <small>Concatenar texto:</small>
                <b-form-checkbox switch v-model="activeSection.joinText" name="input-join-text"
                    class="ml-2"></b-form-checkbox>
            </div>

            <b-button variant="info" class="p-1 mt-2 text-white" size="sm" block
                @click="$bvToast.hide('show-edit-content-title')">
                Guardar <i class="fa fa-check ml-1"></i>
            </b-button>

        </b-toast>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'ContentEditor',
    
    computed: {
        ...mapState('labelDesigner', [
            'activeSection'
        ])
    }
}
</script> 